module.exports = __webpack_public_path__ + "static/img/find_team_icon.6a31444.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/springFestivalActive/recall/find_team_icon.png
// module id = UifS
// module chunks = 1